import { MenuBookOutlined } from "@mui/icons-material";

const DOCS_URL =
  process.env.REACT_APP_DOCS_URL || "http://10.1.69.53:8080/docs/";

// note: grup navigasi khusus dokumentasi (link eksternal, buka tab baru)
const documentationPages = {
  id: "group-documentation",
  title: "",
  type: "group",
  children: [
    {
      id: "documentation",
      title: "Manual Guide",
      caption: "Please use vpn / wifi office",
      type: "item",
      url: DOCS_URL,
      target: true,
      // icon: () => <MenuBookOutlined sx={{ fontSize: 16 }} />,
    },
  ],
};

export default documentationPages;
